<template>    
    <v-container fluid fill-height>
        <v-layout justify-center row pa-4>
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3 mt-2" text-center>
                    <h2>พิมพ์พัสดุนอกเวลา</h2>
                </v-flex>               
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="selectedGroup" inline>
                            <v-radio class="py-1 px-2" label="กรุ๊ปโดยวันที่" value="date"  @click="closeDate"></v-radio>
                            <v-radio class="py-1 px-2"  label="กรุ๊ปประเภทพัสดุ" value="box" @click="openDate"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>                
                <v-row>
                    <v-col cols="12" v-show="isShowDate" class="px-5">
                        <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            style="padding: 0">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                                label="วันที่รับพัสดุ"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" no-title scrollable>
                                <div class="flex-grow-1"></div>
                                <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>    
                    </v-col>               
                </v-row>  
                <v-row>
                    <v-col cols="6">
                        <v-btn color="#0e64ea"
                               block
                               large
                               dark
                               @click="submitExcel()">
                            Excel
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="#1a50a6"
                               block
                               large
                               dark
                               @click="submitPDF()">
                            PDF
                        </v-btn>
                    </v-col>
                </v-row>

            </v-flex>
        </v-layout>
    </v-container>    
</template>

<script>
import EventBus from '@/EventBus'
import axios from '@/axios';

export default {
    name: "OTParcelReport",
    data() {
        return {
            selectedGroup: 'date',
            ntRunno: this.getLocalItem().nt_runno,
            date: new Date().toISOString().substr(0, 10),
            menu: false,
            isShowDate: false,
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'พิมพ์พัสดุนอกเวลา', back_route: 'main-menu'})
    },
    methods: {
        openDate() {
            this.isShowDate = true; 
        },
        closeDate() {
            this.isShowDate = false;
        },
        submitExcel(){
            // console.log("submitExcel");
            let report = `https://reporting.lpn.co.th/flow.html?`
                +`_flowId=viewReportFlow`
                +`&_flowId=viewReportFlow`
                +`&ParentFolderUri=%2FReports%2FParcel&reportUnit=%2FReports%2FParcel%2Flpp_parcel_ot_excel`
                +`&standAlone=true`
                +`&j_username=reportviewer`
                +`&j_password=Dev@2019`
                +`&Status=W`
                +`&Runno=${this.ntRunno}`
                +`&output=xlsx`

            window.open(report);
        },
        submitPDF(){            
            // console.log("submitPDF=",this.searchData.ntRunno);
            //console.log("selectedGroup=",this.selectedGroup);
            // console.log("this.date=",this.date);
            if(this.selectedGroup == "date"){
                let report = `https://reporting.lpn.co.th/flow.html?`
                    +`_flowId=viewReportFlow`
                    +`&_flowId=viewReportFlow`
                    +`&ParentFolderUri=%2FReports%2FParcel&reportUnit=%2FReports%2FParcel%2Flpp_parcel_ot`
                    +`&standAlone=true`
                    +`&j_username=reportviewer`
                    +`&j_password=Dev@2019`
                    +`&Status=W`
                    +`&Runno=${this.ntRunno}`
                    +`&output=pdf`

                window.open(report);
            } else {
                let report = `https://reporting.lpn.co.th/flow.html?`
                    +`_flowId=viewReportFlow`
                    +`&_flowId=viewReportFlow`
                    +`&ParentFolderUri=%2FReports%2FParcel&reportUnit=%2FReports%2FParcel%2Flpp_parcel_ot_by_date`
                    +`&standAlone=true`
                    +`&j_username=reportviewer`
                    +`&j_password=Dev@2019`
                    +`&Status=W`
                    +`&Runno=${this.ntRunno}`
                    +`&AtDate=${this.date}`
                    +`&output=pdf`

                window.open(report);
            }
        },

    }
}
</script>

<style scoped>
</style>